import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { BASE_URL, fetcher, getAuth, sendData } from "../../Models/Fetcher";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import AddIcon from "@material-ui/icons/Add";
import LockIcon from "@material-ui/icons/Lock";
import RemoveIcon from "@material-ui/icons/Remove";
import StorageIcon from "@material-ui/icons/Storage";
import ListAltIcon from "@material-ui/icons/ListAlt";
import DeleteIcon from "@material-ui/icons/Delete";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  actionState,
  codeTableTypeState,
  popupState,
  toastState,
} from "../../Store/atoms";
import { PopupType } from "../../Models/Entities";
import { formatDate } from "../../Utilities/DOMFunctions";
import { useHistory } from "react-router-dom";

interface IDescAccordion {
  favorite: boolean;
  table: any;
  setFavorite: any;
}

const useStyles = makeStyles({
  addtoFavoriteButton: {
    color: "white",
    backgroundColor: "#198754",
    margin: "0.5rem 0",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      color: "white",
      backgroundColor: "#198754",
      boxShadow: "none",
    },
  },
  removeFavoriteButton: {
    color: "white",
    backgroundColor: "#dc3545",
    margin: "0.5rem 0",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      color: "white",
      backgroundColor: "#dc3545",
      boxShadow: "none",
    },
  },

  duplicateButton: {
    color: "white",
    backgroundColor: "#fd7e14 ",
    margin: "0.5rem 0",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      color: "white",
      backgroundColor: "#fd7e14 ",
      boxShadow: "none",
    },
  },

  exportSQLButton: {
    color: "white",
    backgroundColor: "#4357ad",
    margin: "0.5rem 0",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      color: "white",
      backgroundColor: "#4357ad ",
      boxShadow: "none",
    },
  },
  exportCSVButton: {
    color: "white",
    backgroundColor: "#3A5A40",
    margin: "0.5rem 0",
    boxShadow: "none",
    width: "100%",
    "&:hover": {
      color: "white",
      backgroundColor: "#3A5A40",
      boxShadow: "none",
    },
  },
  expandIcon: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DescAccordion = ({ setFavorite, favorite, table }: IDescAccordion) => {
  const classes = useStyles();
  const setPopup = useSetRecoilState(popupState);
  const setAction = useSetRecoilState(actionState);
  const tableType = useRecoilValue(codeTableTypeState);
  const history = useHistory();
  const setToast = useSetRecoilState(toastState);

  const handleAddFavorite = async () => {
    const url =
      BASE_URL + "user/" + localStorage.getItem("userId") + "/favorites";
    const response = await sendData(url, "POST", { tableId: table.id });

    setFavorite(true);
  };

  const handleRemoveFavorite = async () => {
    const url =
      BASE_URL + "user/" + localStorage.getItem("userId") + "/favorites";
    const response = await sendData(url, "DELETE", { tableId: table.id });
    setFavorite(false);
  };

  const handleDuplicate = () => {
    setPopup({ type: PopupType.DuplicateTable, props: null });
  };

  const handleSQL = async () => {
    const url =
      BASE_URL +
      "codetables/" +
      table.id +
      "/sql-export?user=" +
      localStorage.getItem("userId");
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",

      headers: {
        "Content-Type": "text/plain",
        "X-Auth": getAuth(),
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const download = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = download;
        link.setAttribute(
          "download",
          `${table.customer.name}_CodeTable_${table.name}.sql`
        );
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
      });
  };

  const handleCSV = async () => {
    const url =
      BASE_URL +
      "codetables/" +
      table.id +
      "/csv-export?id=" +
      localStorage.getItem("userId") +
      "&type=" +
      tableType;

    const response = await fetch(url, {
      method: "GET",
      mode: "cors",

      headers: {
        "Content-Type": "text/plain",
        "X-Auth": getAuth(),
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const download = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = download;
        link.setAttribute(
          "download",
          `${table.customer.name}_CodeTable_${table.name}.csv`
        );
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
      });
  };

  const handleLock = async () => {
    const lockTable = async () => {
      const response = await sendData(
        BASE_URL + "codetables/" + table.id + "/lock",
        "PUT",
        []
      );
      return response;
    };
    setAction({ action: lockTable });
    setPopup({
      type: PopupType.ConfirmAction,
      props: { message: `Are you sure you want to lock table ${table.name}?` },
    });
  };

  const handleRemoveTable = async () => {
    const removeTable = async () => {
      const response = await sendData(
        `${BASE_URL}codetables/${table.id}`,
        "DELETE",
        []
      );
      history.push("/favorites");
      if (response.status !== 200) {
        setToast({
          open: true,
          severity: "error",
          message: response.data.message,
        });
      }
      setToast({
        open: true,
        severity: "success",
        message: response.data.message,
      });
    };

    setAction({ action: removeTable });
    setPopup({
      type: PopupType.ConfirmAction,
      props: {
        message: `Are you sure you want to delete table ${table.name}?`,
      },
    });
  };

  return (
    <div className="expanded-table">
      <div className="expanded-info">
        <div className="expand__item">{"Customer: " + table.customer.name}</div>
        <div className="expand__item">{"Name: " + table.name}</div>
        <div className="expand__item">
          {"Description: " + table.description}
        </div>
        <div className="expand__item">
          {"Last edited: " + formatDate(table.lastEdited)}
        </div>
      </div>

      <div className="expanded-buttons">
        {favorite && (
          <Button
            startIcon={<RemoveIcon />}
            className={classes.removeFavoriteButton}
            variant="contained"
            onClick={handleRemoveFavorite}
          >
            Remove from favorites
          </Button>
        )}

        {!favorite && (
          <Button
            startIcon={<AddIcon />}
            className={classes.addtoFavoriteButton}
            variant="contained"
            onClick={handleAddFavorite}
          >
            Add to favorites
          </Button>
        )}

        {!table.locked && (
          <Button
            startIcon={<LockIcon />}
            className={classes.removeFavoriteButton}
            variant="contained"
            onClick={handleLock}
          >
            Lock table
          </Button>
        )}

        <Button
          startIcon={<FileCopyIcon />}
          className={classes.duplicateButton}
          variant="contained"
          onClick={handleDuplicate}
        >
          Duplicate table
        </Button>

        <Button
          startIcon={<StorageIcon />}
          className={classes.exportSQLButton}
          variant="contained"
          onClick={handleSQL}
        >
          Export to SQL
        </Button>

        <Button
          startIcon={<ListAltIcon />}
          className={classes.exportCSVButton}
          variant="contained"
          onClick={handleCSV}
        >
          Export to CSV
        </Button>

        <Button
          startIcon={<DeleteIcon />}
          className={classes.removeFavoriteButton}
          variant="contained"
          onClick={handleRemoveTable}
        >
          Delete table
        </Button>
      </div>
    </div>
  );
};

export default DescAccordion;
